import React, { FC } from 'react';

const Title: FC<{ text: string }> = ({ text }) => {
    return (
        <div className="font-semibold text-lg mb-3 text-[#222222]">{text}</div>
    );
};

export default Title;
